import React from "react"

import styles from "./styles.module.scss"

const Dashboard = () => {
  return (
    <div className={styles.container}>
      {/* {isAgentOnboarding && <Onboarding />} */}
    </div>
  )
}

export default Dashboard
